export enum MapViewModeEnum {
  All = "All",
  RouteOnly = "RouteOnly",
  TrackingsOnly = "TrackingsOnly",
}
